export default __webpack_public_path__ + "static/media/MaskGroup257.ec0f4008.png";